import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useRef } from "react";
import ArrowDown from "@engineering/icons/arrow-down";
import { SecondaryText, Ui } from "@silvertours/front-shared";
var generateTimeRange = function() {
    var options = [];
    for(var m = 0; m < 1440; m += 15){
        var time = "".concat(Math.floor(m / 60).toString().padStart(2, "0"), ":").concat((m % 60).toString().padStart(2, "0"));
        options.push({
            label: time,
            value: time
        });
    }
    return options;
};
var TimePicker = function(param) {
    var type = param.type, onChange = param.onChange, pickupTimeText = param.pickupTimeText, pickupTimeLabel = param.pickupTimeLabel, returnTimeText = param.returnTimeText, returnTimeLabel = param.returnTimeLabel, value = param.value;
    var output = useRef(null);
    var timeOptions = generateTimeRange();
    var content = {
        from: {
            label: pickupTimeLabel,
            value: pickupTimeText
        },
        to: {
            label: returnTimeLabel,
            value: returnTimeText
        }
    };
    var setValue = function(newValue) {
        return "".concat(content[type].value, " ").concat(newValue);
    };
    var handleChange = function(event) {
        var ref;
        var _target = event.target, selectedValue = _target.value;
        if ((ref = output.current) === null || ref === void 0 ? void 0 : ref.firstChild) {
            output.current.firstChild.textContent = setValue(selectedValue);
        }
        if (typeof onChange !== "undefined") {
            onChange(selectedValue, type);
        }
    };
    return /*#__PURE__*/ _jsxs("span", {
        className: "color-primary hover:bg-color8 relative flex items-center gap-10 rounded-sm p-10",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "absolute bottom-0 left-0 right-0 top-0 w-full p-0 opacity-0",
                children: /*#__PURE__*/ _jsx(Ui.Dropdown, {
                    design: "compact",
                    id: "".concat(type, "TimeDropdown"),
                    label: content[type].label,
                    options: timeOptions,
                    onChange: handleChange,
                    value: value
                })
            }),
            /*#__PURE__*/ _jsx("output", {
                ref: output,
                children: /*#__PURE__*/ _jsx(SecondaryText, {
                    inline: true,
                    children: setValue(value)
                })
            }),
            /*#__PURE__*/ _jsx(ArrowDown, {
                className: "h-30 w-30 fill-current"
            })
        ]
    });
};
export { TimePicker };
